// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import './bootstrap_custom.js'
import './bs_custom_file_input.js'

import "controllers"

function refreshCsrfToken() {
    const refreshUrl = "/refresh_csrf";
    fetch(refreshUrl, {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        let newToken = data.csrf_token;

        if (newToken) {
          let csrfInput = document.querySelector('input[name="authenticity_token"]');

          if (csrfInput) {
            csrfInput.value = newToken;
            console.log("CSRF token updated.");
          } else {
            console.warn("Input for 'authenticity_token' was not found.");
          }
        }
      })
      .catch(error => {
        console.error('Failed to updated CSRF token', error);
      });
  }
function initializeCsrfRefresh() {
    const csrfInput = document.querySelector('input[name="authenticity_token"]');

    if (csrfInput) {
        const intervalMinutes = 30;
        const intervalMs = intervalMinutes * 60 * 1000;
        //const intervalMs = 5 * 1000;

        setInterval(refreshCsrfToken, intervalMs);
    } else {
        console.log("CSRF input was not found.");
    }
}
document.addEventListener('DOMContentLoaded', initializeCsrfRefresh);

